// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Gfooter from "../Component/Gfooter";
// import "./NewsandEvents1.css";

// function NewsandEvents1() {
//   const [newsCards, setNewsCards] = useState([]);

//   useEffect(() => {
//     const fetchNewsCards = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/news_event_list"
//         );

//         if (response.data.status === "true") {
//           setNewsCards(response.data.data || []);
//         }
//       } catch (error) {
//         console.error("Error fetching news cards:", error);
//       }
//     };

//     fetchNewsCards();
//   }, []);

//   return (
//     <>
//       <section className="news-section">
//         <div className="container">

//           <h2 className="news-heading">News & Events</h2>

//           <div className="timeline">

//             {newsCards.map((item, index) => (
//               <div
//                 key={item.news_id}
//                 className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
//               >
//                 <div className="timeline-content">

//                   <div className="timeline-img">
//                     <img
//                       src={`https://cyberathon.com/NLF/${item.news_image}`}
//                       alt={item.news_heading}
//                     />
//                   </div>

//                   <div className="timeline-text">
//                     <h3>{item.news_heading}</h3>

//                     <Link
//                       to={`/news-events/${item.news_id}`}
//                       className="read-more-btn"
//                     >
//                       Read More →
//                     </Link>
//                   </div>

//                 </div>
//               </div>
//             ))}

//           </div>

//         </div>
//       </section>

//       <Gfooter />
//     </>
//   );
// }

// export default NewsandEvents1;


import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Gfooter from "../Component/Gfooter";
import "./NewsandEvents1.css";

gsap.registerPlugin(ScrollTrigger);

function NewsandEvents1() {

  const [newsCards, setNewsCards] = useState([]);
  const sectionRef = useRef([]);

  useEffect(() => {

    const fetchNewsCards = async () => {
      try {

        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/news_event_list"
        );

        if (response.data.status === "true") {
          setNewsCards(response.data.data || []);
        }

      } catch (error) {
        console.error("Error fetching news cards:", error);
      }
    };

    fetchNewsCards();

  }, []);



  useEffect(() => {

    sectionRef.current.forEach((el) => {

      gsap.fromTo(
        el,
        {
          opacity: 0,
          y: 80
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
          }
        }
      );

    });

  }, [newsCards]);


  return (
    <>
      <section className="news-section">

        <div className="container">

          <h2 className="news-heading">
            News & Events
          </h2>

          {newsCards.map((item, index) => {

            const isReverse = index % 2 !== 0;

            return (

              <div
                key={item.news_id}
                className={`row news-row ${isReverse ? "reverse" : ""}`}
                ref={(el) => (sectionRef.current[index] = el)}
              >

                {/* IMAGE */}

                <div className="col-lg-6">

                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                    className="news-image-box"
                  >

                    <img
                      src={`https://cyberathon.com/NLF/${item.news_image}`}
                      alt={item.news_heading}
                    />

                  </motion.div>

                </div>


                {/* CONTENT */}

                <div className="col-lg-6 d-flex align-items-center">

                  <motion.div
                    initial={{ opacity: 0, x: 60 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    className="news-content"
                  >

                    <h3>{item.news_heading}</h3>

                    <p>
                      {item.news_address}
                    </p>

                    <span className="news-date">
                      {new Date(item.created_at).toDateString()}
                    </span>

                    {/* <Link
                      to={`/news-events/${item.news_id}`}
                      className="news-btn"
                    >
                      Read More
                    </Link> */}
                    <Link
                      to={`/news-events1/${item.news_id}`}
                      className="news-btn"
                    >
                      Read More
                    </Link>

                  </motion.div>

                </div>

              </div>

            );

          })}

        </div>

      </section>

      <Gfooter />

    </>
  );
}

export default NewsandEvents1;